import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRouteHcp = ({ children }) => {
  const isAuthenticated = localStorage.getItem("copayhcpToken");
  return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default PrivateRouteHcp;
